<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    前湾站<br>
站点介绍<br>
前湾站位于听海大道与前湾中路交叉口，5号线车站沿听海大道南北向布置，9号线车站沿前湾中路东西向布置。前湾站是5号线与9号线的换乘站，采用T型换乘方式。前湾站为重点站，装修提取“机舱”的元素，以模数化、标准化的手法结合造型天花及造型灯具，结合空间的结构，打造清新、艺术与装饰相结合的地铁站空间，寓意腾飞、发展。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:18	00:11	5号线	3分钟	5分25秒<br>
黄贝岭	06:24	23:10	5号线	3分钟	5分25秒<br>
前湾	--	--	9号线	3分50秒	5分55秒<br>
文锦	06:20	23:00	9号线	3分50秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:22	00:11	5号线	4分钟	6分钟<br>
黄贝岭	06:29	23:10	5号线	4分钟	6分钟<br>
前湾	--	--	9号线	4分25秒	5分55秒<br>
文锦	06:20	23:00	9号线	4分25秒	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:22	01:11	5号线	4分钟	6分钟<br>
黄贝岭	06:29	00:10	5号线	4分钟	6分钟<br>
前湾	--	--	9号线	4分钟	5分55秒<br>
文锦	06:20	00:00	9号线	4分钟	5分55秒<br><br>

站点出口信息<br>
B出入口:<br>
听海大道、前海大道南侧(东)、九纵二街、桂湾公园<br><br>
D出入口:<br>
前海大道南侧（西）、临海大道、前海法治大厦<br><br>
公交换乘信息<br>
B出入口:<br>
公交站名： 前湾地铁站北<br>
B990<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "wuhaoxian",
          title: "5号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "jiuhaoxian",
          title: "9号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>


